import { CompanyTypeT, CompanyWorkDay } from '../types/companies.types'

export const CompaniesTypes: CompanyTypeT[] = [
    { id: 1, name: 'Юр. лицо' },
    { id: 2, name: 'Физ. лицо' },
    { id: 3, name: 'ИП' },
    { id: 4, name: 'ПВЗ' },
]

export const KASPI_ID = 114
export const DEFAULT_EXCLUDED_COMPANIES_IDS = [KASPI_ID]

export const WORK_WEEK_DAYS = [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
]

export const COMPANY_B2B_DEFAULT_GRAPH: CompanyWorkDay[] = [
    {
        weekday: 1,
        workTimeFrom: '09:00',
        workTimeUntil: '18:00',
    },
    {
        weekday: 2,
        workTimeFrom: '09:00',
        workTimeUntil: '18:00',
    },
    {
        weekday: 3,
        workTimeFrom: '09:00',
        workTimeUntil: '18:00',
    },
    {
        weekday: 4,
        workTimeFrom: '09:00',
        workTimeUntil: '18:00',
    },
    {
        weekday: 5,
        workTimeFrom: '09:00',
        workTimeUntil: '18:00',
    },
]

export const COMPANY_B2C_DEFAULT_GRAPH: CompanyWorkDay[] = [
    {
        weekday: 1,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 2,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 3,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 4,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 5,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 6,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 0,
        workTimeFrom: '09:00',
        workTimeUntil: '21:00',
    },
]
